import { batchesSlice } from '../slices/batchesSlice';

export default batchesSlice.reducer;
